import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { DateTimeInputComponent } from './datetime/datetime.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
    ],
    declarations: [
        DateTimeInputComponent,
    ],
    entryComponents: [],
    exports: [
        DateTimeInputComponent,
    ],
})

export class DateTimeInputModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: DateTimeInputModule,
            providers: []
        };
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/datetime/datetime-input.module.ts